export default function () {
    var body = document.getElementsByTagName('BODY')[0];
    var toggleLanguage = document.getElementById('toggleLanguage');
    var backdrop = document.getElementById('backdrop');
    var shippingAddress = document.querySelector('#same-as-billing');
    var isTouchScreen = false;

    // Check device
    (function () {
        if ('ontouchstart' in document.documentElement) {
            isTouchScreen = true;
        }
    })();

    if (toggleLanguage != null) {
        toggleLanguage.addEventListener('click', function () {
            this.parentElement.classList.toggle('open');
            body.classList.toggle('open-language');
        });
    };

    if (backdrop != null) {
        backdrop.addEventListener('click', function () {
            body.classList.remove('open-search');
            body.classList.remove('open-mainmenu');
        });
    };

    if (isTouchScreen) {
        document.addEventListener('touchend', function (event) {
            toggleNavLink(event);
            togglePopover(event);
            toggleCollapse(event);
            toggleAccessoiresCollapse(event);
            toggleFilterCollapse(event);
            toggleFilterShowAll(event);
            toggleFilterShowLess(event);
            toggleFiltersPopup(event);
            toggleCompanyUspsCollapse(event);
            toggleMainMenu(event);
            toggleSearch(event);
            closeNewsPopup(event);
        });
    } else {
        document.addEventListener('click', function (event) {
            toggleNavLink(event);
            togglePopover(event);
            toggleCollapse(event);
            toggleAccessoiresCollapse(event);
            toggleFilterCollapse(event);
            toggleFilterShowAll(event);
            toggleFilterShowLess(event);
            toggleFiltersPopup(event);
            toggleCompanyUspsCollapse(event);
            toggleMainMenu(event);
            toggleSearch(event);
            closeNewsPopup(event);
        });
    }

    function toggleNavLink(event) {
        if (!event.target.matches('.nav-link-toggle *')) return;
        event.preventDefault();
        event.target.parentElement.parentElement.classList.toggle('show');
    }

    function togglePopover(event) {
        if (!event.target.matches('.c-popover-toggle *')) return;
        event.preventDefault();
        event.target.parentElement.parentElement.parentElement.classList.toggle('show');
    }

    function toggleCollapse(event) {
        if (!event.target.matches('.c-collapse__title')) return;
        event.preventDefault();
        event.target.parentElement.parentElement.classList.toggle('show');
    }

    function toggleAccessoiresCollapse(event) {
        if (!event.target.matches('.c-accessoires-collapse__title')) return;
        event.preventDefault();
        event.target.parentElement.parentElement.classList.toggle('show');
    }

    function toggleFilterCollapse(event) {
        if (!event.target.matches('.c-filter-collapse__title')) return;
        event.preventDefault();
        event.target.parentElement.parentElement.classList.toggle('show');
    }

    function toggleFilterShowAll(event) {
        if (!event.target.matches('.btn-showall')) return;
        event.preventDefault();
        event.target.parentElement.parentElement.classList.toggle('showall');
    }
    function toggleFilterShowLess(event) {
        if (!event.target.matches('.btn-showless')) return;
        event.preventDefault();
        event.target.parentElement.parentElement.classList.toggle('showall');
    }

    function toggleFiltersPopup(event) {
        if (!event.target.matches('.btn-filters-popup')) return;
        event.preventDefault();
        body.classList.toggle('open-filters');
    }

    function toggleCompanyUspsCollapse(event) {
        if (!event.target.matches('.c-company-usps-collapse__title')) return;
        event.preventDefault();
        var x = document.querySelectorAll('.c-company-usps-collapse.show');
        if (x.length > 0) {
            event.target.parentElement.parentElement.classList.toggle('show');
            x.forEach(function (element) {
                element.classList.remove('show');
            });
        }
        else {
            event.target.parentElement.parentElement.classList.toggle('show');
        }
    }

    function toggleMainMenu(event) {
        if (!event.target.matches('.c-mainmenutoggle__btn')) return;
        event.preventDefault();
        body.classList.toggle('open-mainmenu');
        body.classList.remove('open-search');
    }

    function toggleSearch(event) {
        if (!event.target.matches('.c-topsearch__btn')) return;
        event.preventDefault();
        body.classList.toggle('open-search');
        body.classList.remove('open-mainmenu');
        document.getElementById('SearchTerm').focus();
    }

    function closeNewsPopup(event) {
        if (!event.target.matches('.c-newspopup__btn')) return;
        event.preventDefault();
        event.target.parentElement.parentElement.classList.toggle('hide');
    }

    const activeDropdown = document.querySelectorAll('.c-mainmenu .dropdown.active');

    if (activeDropdown.length > 0) {
        activeDropdown.forEach(function (element) {
            element.classList.add('show');
        });
    }

    const toggle = () => document.querySelectorAll('#shipping_address').forEach(label => label.classList.toggle('hidden'));

    if (shippingAddress != null) {
        document.querySelector('#same-as-billing').addEventListener('change', (event) => {
            toggle();
        });
        window.addEventListener('DOMContentLoaded', (event) => {
            if (shippingAddress.checked === true) {
                toggle();
            }
        });
    };

    function parseMarkdown(markdownText) {
        const htmlText = markdownText
            .replace(/\*\*(.*)\*\*/gim, '<b>$1</b>');

        return htmlText.trim();
    }

    const markdownContainers = document.querySelectorAll('.markdown');

    for (var i = 0, len = markdownContainers.length; i < len; i++) {
        markdownContainers[i].innerHTML = parseMarkdown(markdownContainers[i].innerHTML);
    }
}
